import {
  GetBillingUrlRequestBodyType,
  GetBillingUrlResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const getBillingUrl = async (
  payload: ApiRequest<GetBillingUrlRequestBodyType>
) => {
  const resp = await api.post<GetBillingUrlResponseBodyType>(
    `/v2/organizations/billing-url`,
    {
      subscriptionIds: payload.body.subscriptionIds,
      code: payload.body.code,
    }
  );

  return resp.data;
};
export const useGetBillingUrl = () => {
  return useMutation<
    GetBillingUrlResponseBodyType,
    Error,
    ApiRequest<GetBillingUrlRequestBodyType>,
    any
  >({
    mutationKey: ["request-billing-url"],
    mutationFn: async (data) => getBillingUrl(data),
    onSuccess: (data) => {
      if (data.billingUrl) {
        window.location.href = data.billingUrl;
      }
    },
  });
};
